/**
 * @summary     app.eventDispatcher
 * @description Creates an event model for any function so that listeners can be attached when it fires or even prevent it from firing
 * @version     1.0
 * @file        app.eventDispatcher.js
 * @author      Silas Garrison (http://silasgarrison.com/)
 *
 * This source file is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 *
 ** Examples:
 	// Setup a new dispatcher model
 	var dispatcher = app.eventDispatcher();

	// The register method takes in a function and returns a new one that's capable of firing off events
	// If a named function is passed into the register method it can infer the event name from the function
	// i.e. in order to say on.iCanOnlyRunOnMonday, it must know that it's called iCanOnlyRunOnMonday
	iCanOnlyRunOnMonday = dispatcher.register(
		function iCanOnlyRunOnMonday(){
			alert("Cool, it's Monday??");
		}
	);

	// Pass in an anonymous function with the name explicitely defined and an empty execution context
	someoneLetEveryoneKnowIran = dispatcher.register(
		function(){
			return "I ran!";
		},
		// Some execution context, we don't care
		{},
		"someoneLetEveryoneKnowIran"
	);

	// Now, let's actually attach an event to the dispatcher for the Monday function above
	// It'll run before iCanOnlyRunOnMonday is excuted.  If an "on" listener returns false, the method itself won't run
	// accepted formats are on."beforeMethodName", on."methodName", on."afterMethodName"
	// the default of on."methodName" runs after the method, thus the same as on."afterMethodName"
	dispatcher.on(
		"beforeiCanOnlyRunOnMonday",
		function(){
			if(new Date().getDay() !== 1){
				console.log("Sorry, not Monday")
				return false;
			}
		}
	);

	// Now attach an event
	dispatcher.on(
		"someoneLetEveryoneKnowIran",
		function(){
			alert("Hey everyone, he ran!");
		}
	);
*/

app.addFeature(
	"eventDispatcher",
	function(){
		"use strict";

		/*
			Name: create
			Use: API()
			Args: none
			Description: Master function that gets returned as an instance with the prototypes of functions below
		*/
		function create(){
			this.events = {};

			return this;
		}

		/*
			Name: fire
			Use: PRIVATE.fire()
			Args: fn Function (required) - Function to wrap in the event mechanism
					ctx Object (optional - default empty Object) - The context in which to run the function in the fn argument
					name String (required) - Name of the function that's being fired in the fn argument
			Description: Returns a new function which wraps the original in an event model that can handle logic to respond to on events
		*/
		function fire(fn,ctx,name){
			var instance = this;

			return function(){
				var args = Array.fromArguments(arguments);

				// If a before handler has been set and it returns false then assume it needs to not execute the actual method
				if(dispatch.apply(instance,["before" + name,args]) === false){
					return false;
				}

				var res = fn.apply(ctx || {},args);

				// Can be called as on."xyz" or on."afterxyz"
				// put the results into an array and concatenate it with the original arguments passed it so we can use them
				dispatch.apply(
					instance,
					[
						name,
						[res].concat(args)
					]
				);
				dispatch.apply(
					instance,
					[
						"after" + name,
						[res].concat(args)
					]
				);

				return res;
			};
		};

		/*
			Name: register
			Use: INSTANCE.register()
			Args: fn Function (required) - Function to register
					ctx Object (optional - default empty Object) - The context in which to run the function in the fn argument
					name String (required) - Name of the function that's being fired in the fn argument
			Description: Registers a function with the event model and returns a new function
		*/
		create.prototype.register = function(fn,ctx,nm){
			var name = nm || fn.getParts().name,
				instance = this;

			if(!name){
				throw("Anonymous functions cannot be registered with eventDispatcher");
			}

			return fire.apply(instance,[fn,ctx,name]);
		};

		/*
			Name: dispatch
			Use: PRIVATE.dispatch()
			Args: type String - Name of the event we're dispatching
					args Array - Array of arguments to passs to the event being dispatched
			Description: Iterates through events associated with a given event and fires each function
		*/
		function dispatch(type,args){
			var results = null;

			if(Array.isArray(this.events[type])){
				this.events[type].forEach(
					function(fn,idx){
						var res = fn.apply(this,args);

						if(idx === 1){
							results = [results,res];
						}
						else if(idx > 1){
							results.push(res);
						}
						else {
							results = res;
						}
					}
				);
			}

			return results;
		};

		/*
			Name: on
			Use: INSTANCE.on()
			Args: type String - Name of the event (usually a function name) when this event should fire
					fn Function - Function to fire on the event
			Description: Attaches an listener to the event model
		*/
		create.prototype.on = function(){
			var instance = this;

			return (function(type,fn){
				if(instance.events[type]){
					instance.events[type].push(fn);
				}
				else {
					instance.events[type] = [fn];
				}
			});
		};

		// Just return an anonymous function that calls "create" so the feature can be called as: app.eventDispatcher()
		return (
			function(){
				return new create();
			}
		);
	}
);
